import { AnalyticsSenderProvider } from '@funtech-int/yango-shared';
import React, { FC, useEffect } from 'react';
import { useStorage } from '@funtech-int/web-toolkit';

import { useProfileManager } from '@/shared/hooks/useProfileManager';
import { getAvatarsImageUrl } from '@/shared/lib/images';
import { updateProfileSuppressedSession } from '@/shared/lib/profileSession';

import { ProfilesMovieAnnouncePage } from '../ProfilesMovieAnnouncePage/ProfilesMovieAnnouncePage';

interface ProfilesContentProps {
    onHideProfilesChoice: VoidFunction;
    onChooseParentAccount: VoidFunction;
}

export const ProfilesContent: FC<ProfilesContentProps> = ({
    onHideProfilesChoice,
    onChooseParentAccount,
}) => {
    const profileManager = useProfileManager();
    const storage = useStorage();

    useEffect(() => {
        updateProfileSuppressedSession(storage);
    }, [storage]);

    return (
        <AnalyticsSenderProvider>
            <ProfilesMovieAnnouncePage
                onHideProfilesChoice={onHideProfilesChoice}
                onChooseParentAccount={onChooseParentAccount}
                profileOttId={profileManager.userProfile?.ottId || 0}
                profileDisplayName={profileManager.userProfile?.displayName || ''}
                profileHasSubscription={profileManager.hasSubscription.get()}
                profileImage={getAvatarsImageUrl(
                    profileManager.userProfile?.avatarsUrl || '',
                    'orig'
                )}
            />
        </AnalyticsSenderProvider>
    );
};
